import styled, { css } from "styled-components";

export const StyledInput = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${(props) => (props.width ? props.width : "100%")};

  label {    
    font-family: 'Muli', sans-serif;
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    color: #000000;
    margin-bottom: 10px;
    text-transform: capitalize;
  }

  .input-wrap {
    
    font-family: 'Muli', sans-serif;
    height: 46px;
    display: flex;
    width: 100%;
    position: relative;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
  }

  .flex-grow {
    width: 100%;
    flex-grow: 1;
  }

  input {
    font-family: 'Muli', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    background: #FFFFFF;
    height: 46px;
    width: 100%;
    border: 1px solid #F4F4F4;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 15px 10px;
    outline: none;
    transition: all 0.6s;
    width: 100%;
    &:hover,
    &:focus {
      border: 1px solid rgba(64, 25, 109, 0.3);
    }
  }

  input::placeholder {
    color: #cacaca;
  }

  ${(props) =>
    props.size === "lg" &&
    css`
      min-width: ${(props) => (props.width ? props.width : "520px")};
    `}

  ${(props) =>
    props.size === "message" &&
    css`
      text-align: center;
    `}

  ${(props) =>
    props.icon?.length &&
    css`
      input {
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
      }
    `};

  ${(props) =>
    props.error &&
    css`
      input {
        border: 1px solid #F7685B;
      }
    `};


	  ${(props) =>
    props.success &&
    css`
				input {
					border: 2px solid #48D38A;

					&:hover,
					&:focus {
						border: 2px solid #48D38A;
					}
				}
			`};

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.6;
    `};

  ${(props) => props.icon && css``};

  .error {
    margin-top: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #F7685B;
  }

	.success-container {
		display: flex;
		align-items: center;
		margin-top: 10px;

		svg {
			margin-right: 4px;
		}
	}

	.success {
		color: #979797;
		font-size: 16px;
		font-weight: 600;
		line-height: 16px;
  }
`;

export const StyledIconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  margin: 0;
  height: 46px;
  background-color: #eff1ff;
  border: 1px solid #eff1ff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
`;
